import { useEffect, useState } from 'react';

/**
 * Tracks the OS level colour scheme preference. Shared by the app shell and by
 * the standalone pages rendered outside it, so every surface picks the same
 * light/dark theme.
 */
export function usePrefersDarkTheme(): boolean {
  const [prefersDark, setPrefersDark] = useState(
    () => window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia?.('(prefers-color-scheme: dark)');
    if (!mediaQuery) return;

    const handleChange = (e: MediaQueryListEvent) => setPrefersDark(e.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return prefersDark;
}
